var __TEMP__ = require('./_baseGetTag.js');var baseGetTag = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isObjectLike.js');var isObjectLike = __REQUIRE_DEFAULT__(__TEMP__);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isBoolean;
